<template>
  <div>
    <vue-c3 :handler="handler"></vue-c3>
  </div>
</template>

<script>

import Vue from 'vue';
import VueC3 from 'vue-c3';
import * as d3 from 'd3';
require('c3/c3.css');

export default {
  name: 'IspChart',
  components: {
    VueC3
  },
  props: {
    glucoscore: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      handler: new Vue(),
      colorCol: '#7d7e7d',
      smoothColorCol: '#989696',
      ispColors: [
        '#FC3731',
        '#FC3731',
        '#FC3731',
        '#FD722B',
        '#FD722B',
        '#FE8D00',
        '#FFC500',
        '#50BA00',
        '#50BA00',
        '#28C18C',
        '#28C18C'
      ],
      colors: [
        '#3498db'
      ]
    };
  },
  watch: {
    glucoscore: {
      handler: function () {
        this.draw();
      }
    }
  },
  mounted () {
    this.draw();
  },
  computed: {
    getFilteredData () {
      return this.glucoscore
        .filter(item => item.predicted_isp !== null && item.predicted_isp !== undefined && item.predicted_isp > 0)
        .map(item => {
          return {
            isp: Math.round(item.predicted_isp),
            timestamp: item.timestamp,
            type: item.type
          };
        });
    }
  },
  methods: {
    getIspColor (ispValue) {
      const index = Math.floor(ispValue / 10);
      return this.ispColors[Math.min(index, this.ispColors.length - 1)];
    },
    draw () {
      const options = {
        data: {
          x: 'x',
          xFormat: '%Y-%m-%dT%H:%M:%S.%LZ',
          columns: [
            ['x', ...this.getFilteredData.map(item => item.timestamp)],
            ['ISP', ...this.getFilteredData.map(item => item.isp)]
          ]
        },
        color: {
          pattern: this.colors
        },
        axis: {
          x: {
            type: 'timeseries',
            tick: {
              rotate: -30,
              multiline: false,
              format: function (x) {
                let formatSeconds = d3.time.format('%d-%m');
                return formatSeconds(new Date(x));
              }
            },
            height: 50
          },
          y: {
            tick: {
              format: function () { return ''; }
            },
            max: 100,
            min: 0,
            padding: { top: 0, bottom: 0 }
          }
        },
        regions: [
          {axis: 'y', start: 0, end: 10, class: 'ispRegionY1', opacity: 0.2},
          {axis: 'y', start: 10, end: 20, class: 'ispRegionY2', opacity: 0.2},
          {axis: 'y', start: 20, end: 30, class: 'ispRegionY3', opacity: 0.2},
          {axis: 'y', start: 30, end: 40, class: 'ispRegionY4', opacity: 0.2},
          {axis: 'y', start: 40, end: 50, class: 'ispRegionY5', opacity: 0.2},
          {axis: 'y', start: 50, end: 60, class: 'ispRegionY6', opacity: 0.2},
          {axis: 'y', start: 60, end: 70, class: 'ispRegionY7', opacity: 0.2},
          {axis: 'y', start: 70, end: 80, class: 'ispRegionY8', opacity: 0.2},
          {axis: 'y', start: 80, end: 90, class: 'ispRegionY9', opacity: 0.2},
          {axis: 'y', start: 90, end: 100, class: 'ispRegionY10', opacity: 0.2}
        ],
        legend: {
          show: false
        },
        tooltip: {
          contents: (d) => {
            let meal = this.getFilteredData.find(item => new Date(item.timestamp).getTime() === d[0].x.getTime());
            let formatSeconds = d3.time.format('%Y-%m-%d');
            const date = formatSeconds(new Date(d[0].x));
            const ispValue = d[0].value;
            const ispColor = this.getIspColor(ispValue);

            return `<div class='c3-tooltip-container custom-tooltip'>
             <table class='c3-tooltip'>
             <tbody>
                <tr>
                    <th style="background-color:` + this.colorCol + `; "colspan='2'>${date}</th>
                </tr>
              <tr>
              <th  style="background-color:` + this.colorCol + `;">` + this.$t('health.summary.meal') + `</th>
                <th> ${meal.type} </th>
              </tr>
              <tr>
              <th  style="background-color:` + this.colorCol + `;">ISP</th>
              <th style="background-color:` + ispColor + `" colspan="100%">` + ispValue + `</th>
              </tr>
               </tbody>
               </table>
              </div>`;
          }
        }
      };
      this.handler.$emit('init', options);
    }
  }
};
</script>

<style lang="scss">
@import "src/stylesheets/variables";

.ispRegionY1 {
  fill: #FC3731;
}

.ispRegionY2 {
  fill: #FC3731;
}

.ispRegionY3 {
  fill: #FD722B;
}

.ispRegionY4 {
  fill: #FD722B;
}

.ispRegionY5 {
  fill: #FE8D00;
}

.ispRegionY6 {
  fill: #FFC500;
}

.ispRegionY7 {
  fill: #50BA00;
}

.ispRegionY8 {
  fill: #50BA00;
}

.ispRegionY9 {
  fill: #28C18C;
}

.ispRegionY10 {
  fill: #28C18C;
}

</style>



// WEBPACK FOOTER //
// src/brand/health/components/summary/IspChart.vue